/**
 * Factories container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { actions } from './slice';
import {
  factoriesCountSelector,
  factoriesLoadingSelector,
  factoriesSelector,
} from './selectors';
import promisifyActions from '../../Lib/Utils/promisify-actions';
import ComplianceFactories from '../../Components/ComplianceFactories/ComplianceFactories';
import { factoriesExport } from '../../Lib/Utils/Table/table-export';

/**
 * Properties to be provided to the bill payment component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  factories: factoriesSelector(state),
  count: factoriesCountSelector(state),
  loading: factoriesLoadingSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill payment actions
 */
const mapDispatchToProps = (dispatch) => ({
  getFactories: (params) => dispatch(actions.getAll({ params })),
});

/**
 * Connects state to the Vendor Factories component
 *
 * @param {object} mapStateToProps data object to become props for the Factories component
 * @param {object} mapDispatchToProps Factories actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )((props) => (
    <ComplianceFactories {...props} exportFactories={factoriesExport} />
  )),
);
